var map = {
	"./arrow-down.svg": "2e6e",
	"./biomes/autumn-day/cloud-1.png": "1353",
	"./biomes/autumn-day/cloud-2.png": "2d7e",
	"./biomes/autumn-day/forest-1.png": "afea",
	"./biomes/autumn-day/ground.png": "fe8f",
	"./biomes/autumn-day/hill-1.png": "4a46",
	"./biomes/autumn-day/hill-2.png": "5e59",
	"./biomes/autumn-day/house-1.png": "c378",
	"./biomes/autumn-day/house-2.png": "581d",
	"./biomes/autumn-day/plain.png": "abfb",
	"./biomes/autumn-day/plant-1.png": "c375",
	"./biomes/autumn-day/plant-2.png": "999a",
	"./biomes/autumn-day/sky.png": "ba2b",
	"./biomes/autumn-day/statue-1.png": "58a9",
	"./biomes/autumn-day/statue-2.png": "b27a",
	"./biomes/autumn-night/cloud-1.png": "f055",
	"./biomes/autumn-night/cloud-2.png": "d7fd",
	"./biomes/autumn-night/forest-1.png": "b313",
	"./biomes/autumn-night/ground.png": "ec4f",
	"./biomes/autumn-night/hill-1.png": "46de",
	"./biomes/autumn-night/hill-2.png": "55d2",
	"./biomes/autumn-night/house-1.png": "5e4b",
	"./biomes/autumn-night/house-2.png": "3b6d",
	"./biomes/autumn-night/plain.png": "faea",
	"./biomes/autumn-night/plant-1.png": "b3fd",
	"./biomes/autumn-night/plant-2.png": "d148",
	"./biomes/autumn-night/sky.png": "f2e9",
	"./biomes/autumn-night/statue-1.png": "9c38",
	"./biomes/autumn-night/statue-2.png": "0856",
	"./biomes/dolmen-day/cloud-1.png": "8eeb",
	"./biomes/dolmen-day/cloud-2.png": "6f4f",
	"./biomes/dolmen-day/cloud-3.png": "229f",
	"./biomes/dolmen-day/ground.png": "df81",
	"./biomes/dolmen-day/hill-1.png": "4e4f",
	"./biomes/dolmen-day/hill-2.png": "65ed",
	"./biomes/dolmen-day/hill-3.png": "4183",
	"./biomes/dolmen-day/hill-4.png": "c15a",
	"./biomes/dolmen-day/plant-1.png": "286a",
	"./biomes/dolmen-day/plant-2.png": "cadd",
	"./biomes/dolmen-day/sky.png": "b506",
	"./biomes/dolmen-night/cloud-1.png": "5d6e",
	"./biomes/dolmen-night/cloud-2.png": "4ac5",
	"./biomes/dolmen-night/cloud-3.png": "151a",
	"./biomes/dolmen-night/ground.png": "c94a",
	"./biomes/dolmen-night/hill-1.png": "f87a",
	"./biomes/dolmen-night/hill-2.png": "a274",
	"./biomes/dolmen-night/hill-3.png": "01b4",
	"./biomes/dolmen-night/hill-4.png": "8569",
	"./biomes/dolmen-night/plant-1.png": "a8d8",
	"./biomes/dolmen-night/plant-2.png": "fc00",
	"./biomes/dolmen-night/sky.png": "6fc5",
	"./biomes/temple-day/columns.png": "3e44",
	"./biomes/temple-day/ground.png": "a205",
	"./biomes/temple-day/roof.png": "4547",
	"./biomes/temple-day/sky.png": "4c49",
	"./biomes/winter-day/forest.png": "b798",
	"./biomes/winter-day/ground.png": "acd7",
	"./biomes/winter-day/hill-2.png": "fa5f",
	"./biomes/winter-day/hill-3.png": "d3a6",
	"./biomes/winter-day/hill-4.png": "e681",
	"./biomes/winter-day/hill-5.png": "3418",
	"./biomes/winter-day/hill-6.png": "ada8",
	"./biomes/winter-day/mountains.png": "fd86",
	"./biomes/winter-day/pike.png": "4856",
	"./biomes/winter-day/sky.png": "9d08",
	"./biomes/winter-night/forest.png": "a370",
	"./biomes/winter-night/ground.png": "aca7",
	"./biomes/winter-night/hill-2.png": "2bba",
	"./biomes/winter-night/hill-3.png": "0aa4",
	"./biomes/winter-night/hill-4.png": "7828",
	"./biomes/winter-night/hill-5.png": "0591",
	"./biomes/winter-night/hill-6.png": "e4ee",
	"./biomes/winter-night/mountains.png": "b80f",
	"./biomes/winter-night/pike.png": "2e14",
	"./biomes/winter-night/sky.png": "c6d5",
	"./button-small.png": "e113",
	"./button.png": "8ed0",
	"./card-bg-armor.png": "beaa",
	"./card-bg-attack.png": "fdb7",
	"./card-bg-default.png": "a51b",
	"./card-bg-gold.png": "ba78",
	"./card-bg-life.png": "778b",
	"./card-bg-scroll.png": "1dc1",
	"./cards/enemy/dragon-attack.png": "5aab",
	"./cards/enemy/dragon-hit.png": "83c8",
	"./cards/enemy/dragon-idle.png": "c569",
	"./cards/enemy/eyes-attack.png": "274f",
	"./cards/enemy/eyes-hit.png": "70cd",
	"./cards/enemy/eyes-idle.png": "4e22",
	"./cards/enemy/fire-attack.png": "849d",
	"./cards/enemy/fire-hit.png": "246a",
	"./cards/enemy/fire-idle.png": "b64b9",
	"./cards/enemy/gargoyle-attack.png": "83c7",
	"./cards/enemy/gargoyle-hit.png": "f872",
	"./cards/enemy/gargoyle-idle.png": "c027",
	"./cards/enemy/king-attack.png": "27d6",
	"./cards/enemy/king-hit.png": "3fd8",
	"./cards/enemy/king-idle.png": "bd24",
	"./cards/enemy/leaf-attack.png": "8dc4",
	"./cards/enemy/leaf-hit.png": "4b07",
	"./cards/enemy/leaf-idle.png": "77bf",
	"./cards/enemy/pigeon-attack.png": "588a",
	"./cards/enemy/pigeon-hit.png": "7f64",
	"./cards/enemy/pigeon-idle.png": "9688",
	"./cards/enemy/tentacle-attack.png": "c4e5",
	"./cards/enemy/tentacle-hit.png": "5411",
	"./cards/enemy/tentacle-idle.png": "3b88",
	"./cards/enemy/tongue-attack.png": "ac81",
	"./cards/enemy/tongue-hit.png": "6420",
	"./cards/enemy/tongue-idle.png": "6afa",
	"./cards/enemy/vampire-attack.png": "c291",
	"./cards/enemy/vampire-hit.png": "f722",
	"./cards/enemy/vampire-idle.png": "d0cc",
	"./cards/gold/emerald.png": "d246",
	"./cards/hero/barrel-attack.png": "b6ce",
	"./cards/hero/barrel-hit.png": "0c69",
	"./cards/hero/barrel-idle.png": "4aac",
	"./cards/hero/carrot-attack.png": "f3fe",
	"./cards/hero/carrot-hit.png": "0a43",
	"./cards/hero/carrot-idle.png": "b400",
	"./cards/hero/fish-attack.png": "8563",
	"./cards/hero/fish-hit.png": "9641",
	"./cards/hero/fish-idle.png": "e3ae",
	"./cards/hero/spider-attack.png": "a7c3",
	"./cards/hero/spider-hit.png": "78da",
	"./cards/hero/spider-idle.png": "f571",
	"./cards/hero/wolf-attack.png": "9674",
	"./cards/hero/wolf-hit.png": "9d87",
	"./cards/hero/wolf-idle.png": "ab25",
	"./cards/item/feather.png": "fba6",
	"./cards/item/health-potion.png": "62e9",
	"./cards/item/poison-potion.png": "dd6c",
	"./cards/item/strength-potion.png": "c6f6",
	"./cards/item/weakness-potion.png": "9828",
	"./cards/scroll/default.png": "4f3e",
	"./cards/shield/bronze-shield.png": "644e",
	"./cards/shield/cursed-shield.png": "70bc",
	"./cards/shield/golden-shield.png": "415d",
	"./cards/shield/iron-shield.png": "43f9",
	"./cards/shield/wooden-shield.png": "ce47",
	"./cards/talisman/amphora.png": "9b73",
	"./cards/talisman/asticot.png": "af8e",
	"./cards/talisman/baby-bird.png": "5035",
	"./cards/talisman/book.png": "d4d6",
	"./cards/talisman/chalice.png": "06cd",
	"./cards/talisman/dragonfly-flask.png": "c297",
	"./cards/talisman/ear.png": "8a94",
	"./cards/talisman/fish-head.png": "a8d0",
	"./cards/talisman/fish-skeleton.png": "00e2",
	"./cards/talisman/flower.png": "04cc",
	"./cards/talisman/fork.png": "035b",
	"./cards/talisman/gnome.png": "dab5",
	"./cards/talisman/gold-tooth.png": "de53",
	"./cards/talisman/goldsun-brooch.png": "76ea",
	"./cards/talisman/hand-dice.png": "b3ac",
	"./cards/talisman/head-in-head.png": "60f6",
	"./cards/talisman/keeps.png": "bd57",
	"./cards/talisman/letter.png": "0f7f",
	"./cards/talisman/pyramidal-fruit.png": "2f1c",
	"./cards/talisman/ring.png": "076b",
	"./cards/talisman/shell.png": "53d6",
	"./cards/talisman/shop-dice.png": "98e4",
	"./cards/talisman/wounded-heart.png": "8f74",
	"./cards/talisman/zombie-hand.png": "561b",
	"./cards/trap/pikes-trap.png": "cb12",
	"./cards/trap/puddle.png": "fce4",
	"./cards/trap/wolf-trap.png": "6dc0",
	"./cards/weapon/axe.png": "2ee3",
	"./cards/weapon/dagger.png": "9e95",
	"./cards/weapon/golden-sword.png": "74cd",
	"./cards/weapon/hammer.png": "e9ee",
	"./cards/weapon/lance.png": "3a60",
	"./cards/weapon/mace.png": "5ae3",
	"./cards/weapon/staff.png": "13de",
	"./cards/weapon/sword.png": "afaf",
	"./credits/bg-credits.png": "3969",
	"./credits/christophe.png": "7258",
	"./credits/damien.png": "fdd0",
	"./credits/jeanne.png": "2664",
	"./crown.png": "8dce",
	"./diamond.png": "a8b9",
	"./end-turn-button.png": "20da",
	"./hero-infos.png": "b131",
	"./heroes/bg.png": "89ae",
	"./heroes/boss.png": "4566",
	"./heroes/bubble.png": "c50c",
	"./heroes/chair.png": "a653",
	"./heroes/chairs.png": "b0ac",
	"./hit-animation.png": "1d89",
	"./home/barrel.png": "da49",
	"./home/bg.png": "2de1",
	"./home/button.png": "522a",
	"./home/fish.png": "123e",
	"./home/spider.png": "e911",
	"./logo.png": "4ffd",
	"./shop/bg.png": "c0e8",
	"./shop/bubble.png": "15b7",
	"./shop/foreground.png": "b1bb",
	"./shop/merchant.png": "c1e5",
	"./shop/poster-1.png": "877e",
	"./shop/poster-2.png": "76f6",
	"./shop/poster-3.png": "b98f",
	"./shop/scotch.png": "5160",
	"./shop/shadows.png": "c0f9",
	"./shop/sign.png": "db88",
	"./shop/table.png": "1f70",
	"./status-info.png": "a22d",
	"./tooltip-title.png": "9b7f",
	"./tooltip.png": "bbd7",
	"./ui/armor.png": "63be",
	"./ui/attack.png": "3b47",
	"./ui/cursor-dark.png": "3011",
	"./ui/cursor-light.png": "f4af",
	"./ui/gold.png": "d627",
	"./ui/life.png": "c2b5",
	"./ui/poison.png": "6a7e",
	"./ui/strength.png": "ccb8",
	"./ui/weakness.png": "c72c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b708";